import React, { useEffect, useState } from 'react';
import '../Groups.less';
import { message, Modal, Form } from 'antd';
import { useQueryClient } from '@tanstack/react-query';
import NewCustomButton from '../../Common/NewCustomButton';
import { ButtonTypes } from '../../Common/CustomButton';
import { useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { CloseIcon, NewCloseIcon, NewUpdateIcon, DeleteIcon } from '../../Common/Icons';
import { GroupModalActions } from '@vantiva-sa/homesight_humaui/Utilities/Constants';
import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';

const GroupAddEdit = ({
  closeGroupModal,
  groupModalAction,
  groupDeleteAction,
  record,
  setRefreshGroupList,
  setGroupName,
  closeGroupModalHandler,
}) => {
  const trans = useSelector(translator);
  const userGroupApi = useSelector((state) => state.apis.userGroupApi);
  const [form] = Form.useForm();
  const [processing, setProcessing] = useState(false);
  const isEditMode = groupModalAction === GroupModalActions.editGroup;

  const queryClient = useQueryClient();

  useEffect(() => {
    if (isEditMode && record) {
      form.setFieldsValue({
        groupName: record.name,
        groupDescription: record.description,
      });
    } else {
      form.resetFields();
    }
  }, [isEditMode, record, form]);

  const handleSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        const groupData = {
          name: values.groupName,
          description: values.groupDescription || '',
        };

        setProcessing(true);

        if (isEditMode) {
          userGroupApi.updateUserGroup(
            record.groupuuid,
            groupData,
            apiCallback({
              translator: trans,
              failCallback: handleError,
              errorCallback: handleError,
              successCallback: handleUpdateSuccess,
            })
          );
        } else {
          userGroupApi.createUserGroup(
            { ...groupData, contacts: [] },
            apiCallback({
              translator: trans,
              failCallback: handleError,
              errorCallback: handleError,
              successCallback: handleCreateSuccess,
            })
          );
        }
      })
      .catch((info) => {
        console.error('Validate Failed:', info);
      });
  };

  const handleCreateSuccess = (data) => {
    setProcessing(false);
    form.resetFields();

    setRefreshGroupList((prev) => !prev); // Trigger refresh of group list
    // message.success("Group created successfully!");
    closeGroupModalHandler();
    queryClient.invalidateQueries({ queryKey: ['adminDashboardByDateTime'] });
  };

  const handleUpdateSuccess = (data) => {
    setProcessing(false);
    const updatedGroupName = form.getFieldValue('groupName');
    setGroupName(updatedGroupName);
    // message.success("Group updated successfully!");
    closeGroupModalHandler();
  };

  const handleError = (error) => {
    setProcessing(false);
    // message.error(isEditMode ? "Error updating group!" : "Error creating group!");
    console.error('Error:', error);
  };

  return (
    <>
      <div className="modal-container">
        {/* Header Section */}
        <div className="group-modal-header-container">
          <div className="group-header-icon-title-new-container">
            <div className="group-modal-header-info">
              <div className="group-header-title-new">
                {isEditMode ? trans('EDITGROUP') : trans('CREATEGROUP')}
              </div>
              <div className="group-header-sub-title">
                {isEditMode
                  ? trans('EDITTHEGROUPNAMEANDDESCRIPTION')
                  : trans('EDITAGROUPNAMEANDDESCRIPTION')}
              </div>
            </div>
          </div>
          <div className="group-modal-close-button" onClick={closeGroupModal}>
            <CloseIcon width="20" />
          </div>
        </div>

        {/* Form Section */}
        <Form form={form} initialValues={{ groupName: '', groupDescription: '' }}>
          <div className="groups-form-container">
            <div className="form-group">
              <label htmlFor="groupName" className="form-field-title">
                {trans('GROUPNAME*')}
              </label>
              <Form.Item
                name="groupName"
                rules={[
                  {
                    required: true,
                    message: trans('PLEASEENTERTHEGROUPNAME'),
                  },
                ]}
                style={{ marginBottom: '0' }}
                className="form-error-item"
              >
                <input
                  type="text"
                  id="groupName"
                  className="form-input"
                  placeholder={trans('GROUPNAME')}
                />
              </Form.Item>
            </div>

            <div className="form-group">
              <label htmlFor="groupDescription" className="form-field-title">
                {trans('DESCRIPTION')}
              </label>
              <Form.Item
                name="groupDescription"
                style={{ marginBottom: '0' }}
                className="form-error-item"
              >
                <input
                  type="text"
                  id="groupDescription"
                  className="form-input"
                  placeholder={trans('DESCRIPTION')}
                />
              </Form.Item>
            </div>
          </div>
        </Form>

        {/* Footer Buttons */}
        <div className="modal-footer">
          {isEditMode && (
            <NewCustomButton
              className="delete-form-icon"
              label={trans('DELETEGROUP')}
              icon={<DeleteIcon style={{ fill: '#113E57' }} />}
              onClick={groupDeleteAction}
            />
          )}

          <NewCustomButton
            className="cancel-form-icon"
            label={trans('CANCEL')}
            icon={<NewCloseIcon style={{ fill: '#113E57' }} />}
            onClick={closeGroupModalHandler}
          />
          <NewCustomButton
            disabled={processing}
            type={ButtonTypes.primary}
            label={isEditMode ? trans('UPDATE') : trans('CREATEGROUP_U')}
            icon={
              <NewUpdateIcon style={{ fill: '#003252' }} className="create-group-icon-enabled" />
            }
            onClick={handleSubmit}
          />
        </div>
      </div>
    </>
  );
};

export default GroupAddEdit;
